<template>
  <slideshow
    @previous="goToPreviousMonth"
    @next="goToNextMonth"
  >
    <template slot="title">
      {{ getMonthLabel }}
      <small>{{ getSeasonLabel }}</small>
    </template>
    <template slot>
      <month
        class="calendar-month"
        :month="getMonth"
        :year="getYear"
        :activeDays="daysWithStrips"
        @click="goToDate"
      />
    </template>
  </slideshow>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import { MONTHFORMAT, DATEFORMAT } from '@/utilities/time';
import Month from '@/components/calendar/Month.vue';
import Slideshow from '@/components/Slideshow.vue';

export default {
  name: 'CalendarMonth',
  components: {
    Slideshow,
    Month,
  },
  computed: {
    ...mapGetters(['getAllStrips', 'getAllSeasons']),
    getYear() {
      return this.dayjs().year();
    },
    getMonth() {
      return this.dayjs().month();
    },
    getMonthLabel() {
      return this.dayjs().format('MMM YYYY');
    },
    getSeasonLabel() {
      const findSeason = () => this.getAllSeasons.find((season) => {
        const seasonStart = dayjs.unix(season.startDate.seconds);
        const seasonEnd = dayjs.unix(season.endDate.seconds);
        const startsBefore = seasonStart.isBefore(this.dayjs());
        const startsAfter = seasonStart.isAfter(this.dayjs());
        const startsDuring = startsAfter && seasonStart.isBefore(this.dayjs().add(1, 'month'));
        const endsAfter = seasonEnd.isAfter(this.dayjs());
        const endsDuring = endsAfter && seasonEnd.isBefore(this.dayjs().add(1, 'month'));
        return (startsBefore || startsDuring) && (endsDuring || endsAfter);
      });
      const season = this.getAllSeasons && findSeason();
      return season ? season.name : 'No active season';
    },
    daysWithStrips() {
      const strips = this.getAllStrips() || [];
      return strips.map(
        strip => dayjs.unix(strip.publishDate.seconds).format(DATEFORMAT),
      );
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route() {
      this.fetchData();
    },
  },
  methods: {
    ...mapActions(['fetchAllStrips', 'createStrip', 'updateStrip']),
    dayjs() {
      const { month } = this.$route.query;
      return month ? dayjs(`${month}-01`) : dayjs();
    },
    fetchData() {
      this.fetchAllStrips();
    },
    goToPreviousMonth() {
      const newDate = this.dayjs().subtract(1, 'month');
      this.$router.push({ query: { month: newDate.format(MONTHFORMAT) } });
    },
    goToNextMonth() {
      const newDate = this.dayjs().add(1, 'month');
      this.$router.push({ query: { month: newDate.format(MONTHFORMAT) } });
    },
    goToDate(date) {
      this.$router.push({
        name: 'CalendarDay',
        params: {
          publishDate: dayjs(date).format('YYYY-MM-DD'),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar-month {
  width: 100%;
}
</style>
